$(document).ready(function(){
  var windowHeight = $(window).height();
  var titleHeight = $('.title').height();
  var windowWidth = $(window).width();
  var titleWidth = $('.title').width();
  var titlePosX = $('.title').offset().left;
  var titlePosY = $('.title').offset().top;
  $('.title').css('transform','translate('+(((windowWidth-titleWidth)/2)-titlePosX)+'px,'+(((windowHeight-titleHeight)/2))+'px)');
  $('.title').addClass('active');
  setTimeout(function(){
    $('.title').css('transition','600ms');
    $('.title').addClass('active2');
    $('header').addClass('active');
    $('.header_menu').fadeIn(800);
    $('.overlay_white').fadeOut(800);
    $('.title').css('transform','translate(0,0)');
  },1400);
  setTimeout(function(){
    $('.title').css('z-index','0');
    $('.mv').addClass('active');
    $('.menu_btn_box').addClass('active');
  },2000);
});



$(function(){
  // ページ内リンク
  var pageLink=$('[href^="#"]');
  $(pageLink).click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position=target.offset().top;
    $("html, body").animate({scrollTop:position}, 500, "swing");
    return false;
  });
  // スクロールアクション
  $(window).on('load scroll',function(){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    var titlePos = $('.mv_title').offset().top;
    if (scroll > titlePos) {
      $('.bottom_chara').addClass('active');
    }else{
      $('.bottom_chara').removeClass('active');
    }
    $('.scroll_action').each(function (){
        var This =$(this);
        var elemPos = This.offset().top;
        var w = $( window ).width() ;
        if(This.hasClass('bottom_action')){
          var triggerHeight = windowHeight*0.1;
        }else{
          var triggerHeight = windowHeight*0.4;
        }
        if (scroll > elemPos - windowHeight + triggerHeight){
          This.addClass('active');
        }
    });
    $('.trigger').each(function (){
        var This =$(this);
        var triggerPos = This.offset().top;
        var sectionHeight = This.outerHeight();
        var num = This.data('n');
        if (num == 7) {
          if (scroll > triggerPos - windowHeight * 0.8) {
            $('.bottom_chara ul li.group'+num).addClass('active');
          }else{
            $('.bottom_chara ul li.group'+num).removeClass('active');
          }
        }else if(num == 1){
          if (scroll < triggerPos - windowHeight * 0.8 + sectionHeight) {
            $('.bottom_chara ul li.group'+num).addClass('active');
          }else{
            $('.bottom_chara ul li.group'+num).removeClass('active');
          }
        }else{
          if ((scroll > triggerPos - windowHeight * 0.8) && (scroll < triggerPos - windowHeight * 0.8 + sectionHeight)) {
            $('.bottom_chara ul li.group'+num).addClass('active');
          }else{
            $('.bottom_chara ul li.group'+num).removeClass('active');
          }
        }
    });
  });

  setInterval(function(){
    $('.bottom_chara ul li').removeClass('anim');
    var randomNum = Math.floor(Math.random() * ((22 + 1) - 1)) + 1;
    $('.bottom_chara ul li:nth-child('+randomNum+')').addClass('anim');
  },4000);

  $(window).on('load resize',function(){
    $('.section_wrapper').each(function (){
      var blockHeight = $(this).find('.section_block2').height();
      var textHeight = $(this).find('.section_text2').height();
      var topSpace = blockHeight - textHeight - 70;
      $(this).find('.section_block2').css('margin-top','-'+topSpace+'px');
    });
  });

  $('.menu_btn_box').click(function(){
    $('.header_wrapper').toggleClass('open');
  });
  $('.header_menu a').click(function(){
    $('.header_wrapper').removeClass('open');
  });

  var mainSwiper = new Swiper('#slider', {
    // パラメーター
    loop: true,
    slidesPerView: 4,
    speed:4000,
    allowTouchMove: false,
    autoplay: {delay: 0},
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween:20
      }
    }
  });
  $(window).resize(function(){
      mainSwiper.autoplay.paused = false;
      mainSwiper.autoplay.start();
  });


  // modal
  $(function(){
    $('.swiper-slide').click(function(){
      var modalImg = $(this).html();
      $('body').append('<div class="modal_bg flex flex_middle flex_center"><div class="modal_img">'+modalImg+'</div></div>');
      $('body').css('overflow','hidden');

      $('.modal_bg').click(function(){
        $(this).remove();
        $('body').css('overflow','auto');
      });
    });
  });

});
